export enum EWeek {
  SUN,
  MON,
  TUE,
  WED,
  THU,
  FRI,
  SAT
}
